import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import CouponServices from '../../services/CouponServices';

function UpdateCoupon({ coupon, closeModal, onSuccess }) {
    const [formValues, setFormValues] = useState({
        name: "",
        description: "",
        image: '',
        minimumPrice: "",
        numberOfCoupons: "",
        startDate: "",
        endDate: "",
        discountValue: "",
        discountType: "",
        status: ""
    });
    const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return ''; // Return an empty string for invalid dates
        }
        const year = date.getFullYear().toString();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        if (coupon) {
            setFormValues({
                name: coupon?.name || '',
                description: coupon?.description || '',
                image: coupon?.image || '',
                minimumPrice: coupon?.minimumPrice || '',
                numberOfCoupons: coupon?.numberOfCoupons || '',
                startDate: coupon?.startDate ? formatDate(coupon?.startDate) : '',
                endDate: coupon?.endDate ? formatDate(coupon?.endDate) : '',
                discountValue: coupon?.discountValue || '',
                discountType: coupon?.discountType || '',
                status: coupon?.status || '',
            });
            if (coupon.image) {
                setPreviewImage(process.env.REACT_APP_URL + coupon.image);
            }
        }
    }, [coupon]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImage(reader.result);
            };
            reader.readAsDataURL(file);
            setFormValues({
                ...formValues,
                image: file,
            });
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        // Validation for date range
        if (new Date(formValues.endDate) <= new Date(formValues.startDate)) {
            alert('End Date should be greater than Start Date.');
            return;
        }
        try {
            const formData = new FormData();
            for (const key in formValues) {
                if (key !== 'image' || formValues[key] instanceof File) {
                    formData.append(key, formValues[key]);
                }
            }

            await CouponServices.updateCoupon(coupon.id, formData);
            alert('Coupon updated successfully');
            onSuccess();
            closeModal();
        } catch (error) {
            console.error('Failed to update Coupon', error);
            alert( error.response.data.message ||'Failed to update Coupon');
        }
    };

    return (
        <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title"> Edit Coupon</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <div className="container-box px-5">
                            <div className="container-box-inner">
                                <div className="page-details">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label>Coupon Code</label>
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        className="form-control"
                                                        value={formValues.name}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Coupon Code Name"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label>Discount Type</label>
                                                    <select className="form-select" name="discountType" onChange={handleInputChange} value={formValues.discountType} required>
                                                        <option selected="">Select Discount Type</option>
                                                        <option value="Percentage">Percentage (%)</option>
                                                        <option value="FixedRate">Fixed Rate</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label>Discount Value</label>
                                                    <input
                                                        type="number"
                                                        name="discountValue"
                                                        className="form-control"
                                                        value={formValues.discountValue}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Discount Value"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label>Start Date</label>
                                                    <input
                                                        type="date"
                                                        name="startDate"
                                                        className="form-control"
                                                        value={formValues.startDate}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Start Date"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label>End Date</label>
                                                    <input
                                                        type="date"
                                                        name="endDate"
                                                        className="form-control"
                                                        value={formValues.endDate}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter End Date"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label>Usage Limit</label>
                                                    <input
                                                        type="number"
                                                        name="numberOfCoupons"
                                                        className="form-control"
                                                        value={formValues.numberOfCoupons}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter Usage Limit"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label htmlFor="imageUpload" className="form-label">Image</label>
                                                    <input
                                                        type="file"
                                                        name="image"
                                                        className="form-control"
                                                        id="imageUpload"
                                                        onChange={handleFileChange}
                                                        accept="image/*"
                                                    />
                                                    <div
                                                        className="file-preview d-flex"
                                                        style={{ marginBlock: "20px", alignItems: "center", justifyContent: "center" }}
                                                    >
                                                        <img
                                                            id="uploadFile"
                                                            src={previewImage}
                                                            alt="Preview"
                                                            style={{ maxWidth: "100%", height: "auto", border: "1px solid #ddd", borderRadius: "8px" }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label>Minimum Order Value (Optional)</label>
                                                    <input
                                                        type="number"
                                                        name="minimumPrice"
                                                        className="form-control"
                                                        value={formValues.minimumPrice}
                                                        onChange={handleInputChange}
                                                        placeholder="Set Minimum Order Value"

                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="input-field">
                                                    <label>Status</label>
                                                    <select className="form-select" name="status" value={formValues.status} onChange={handleInputChange} required>
                                                        <option selected="">Select Status</option>
                                                        <option value="Active">Active </option>
                                                        <option value="Inactive">Expire</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="input-field">
                                                    <label>Description</label>
                                                    <textarea
                                                        className="form-control video-desc"
                                                        name="description"
                                                        value={formValues.description}
                                                        onChange={handleInputChange}
                                                        placeholder='Description'
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <button className="site-btn-green">Save</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateCoupon;
